module.exports = __webpack_public_path__ + "img/farzana-christopher-154.b48ba68f.jpg";